import {DASHBOARD_GET_ACTION, DASHBOARD_GET_CLOCKED_IN_EMPLOYEES_ACTION, DASHBOARD_GET_POPULAR_JOB_SITE_ACTION} from "../../constants/actions"

const initialState = {
    list: {},
    clockedInEmployees: {
        status: false,
        data: {
            count: 0,
            employees: []
        }
    },
    popularJobSite: {
        status: false,
        data: {
            job_site_name: '',
            tickets_count: 0
        }
    }
}

const dashboardReducer = (state = initialState, action) => {

    switch (action.type) {

        case DASHBOARD_GET_ACTION:
            return {
                ...state,
                list: action.list
            }
        case DASHBOARD_GET_CLOCKED_IN_EMPLOYEES_ACTION:
            return {
                ...state,
                clockedInEmployees: action.payload
            }
        case DASHBOARD_GET_POPULAR_JOB_SITE_ACTION:
            return {
                ...state,
                popularJobSite: action.payload
            }
        default: return state
    }
}

export default dashboardReducer